export default {
  facebook: 'Facebook',
  twitter: 'Twitter',
  github: 'Github',
  linkedin: 'LinkedIn',
  google: 'Google Plus'
}
